import { GenericValue } from 'hisng';

// notwendige Personendaten für Zuordnungen/externe Personen
export class Person {
    // attributes #################################
    id: number;
    surname: string;
    firstname: string;
    birthdate: Date;
    birthname: string;
    birthcity: string;

    country: GenericValue;
    gender: GenericValue;
    title: GenericValue;
    academicdegree: AcademicDegree;
    academicdegreesuffix: string;

    // for intern only ##########################
    lockVersion: number;

    constructor( id?: number, surname?: string, firstname?: string, gender?: GenericValue ) {
        this.id = id;
        this.surname = surname;
        this.firstname = firstname;
        this.gender = gender;
    }
}

export class AcademicDegree extends GenericValue {
    lettersalutation: string;
    lettersalutationFemale: string;
    positionOfTitle: number;
}
